import type { Property } from "@ext/properties/models";
import { Popover, PopoverContent, PopoverTrigger } from "@ui-kit/Popover";
import type { ReactNode } from "react";
import { ArticlePropertiesPopoverContent } from "./ArticlePropertiesPopoverContent";

interface ArticlePropertiesPopoverProps {
	trigger: ReactNode;
	properties: Property[];
	catalogProperties: Map<string, Property>;
	isReadOnly: boolean;
	onSubmit: (id: string, value?: string) => void;
	onDelete: (id: string) => void;
}

export const ArticlePropertiesPopover = ({ trigger, isReadOnly, ...contentProps }: ArticlePropertiesPopoverProps) => {
	if (isReadOnly) return null;

	return (
		<Popover modal={false}>
			<PopoverTrigger asChild>{trigger}</PopoverTrigger>
			<PopoverContent
				align="end"
				className="flex max-h-[50vh] w-[min(22rem,calc(100vw-1rem))] flex-col p-0 sm:max-h-[65dvh]"
				data-testid="article-properties-popover"
				onOpenAutoFocus={(e) => e.preventDefault()}
			>
				<ArticlePropertiesPopoverContent {...contentProps} />
			</PopoverContent>
		</Popover>
	);
};
